import classNames from 'classnames';
import React from 'react';

import css from './IconMeat.module.css';

const IconMeat = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      enableBackground="new 0 0 48 48"
    >
      <g id="icons">
        <path
          d="M44.4 12.6c-1.7-1.5-4.3-2.1-8.1-3C31 8.2 14.6 7 8.8 8.2 3 9.4.5 11.8 1.1 14.1c.6 2.3 4.5 4.5 6 5.6 2.1 1.5 6.3 7.8 10.4 9.3 3.4 1.2 8 2 15 0 3.4-1 5.4-2.4 8.3-4.1 2.6-1.6 5.5-4.4 6.1-7 .6-2.5-.9-3.8-2.5-5.3z"
          fill="none"
          stroke="#011602"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M1 14v10c0 1.9 4.6 4.6 6 5.7 2.1 1.5 6.3 7.8 10.4 9.3 3.4 1.2 8 2 15 0 3.4-1 5.5-2.4 8.4-4.1C43.4 33.3 47 30 47 28V18"
          fill="none"
          stroke="#011602"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <ellipse
          cx="16"
          cy="15.5"
          rx="4"
          ry="2.5"
          fill="none"
          stroke="#011602"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};

export default IconMeat;
